require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-test-banzai-calculator.json") })
        }
      }, "path---calculators-test-banzai-calculator");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-test-banzai-calculator!./.cache/json/calculators-test-banzai-calculator.json
// module id = 2025
// module chunks = 231608221292675